import { Link } from "@tanstack/react-router";
import { useIsAdmin } from "../hooks/useAuthGuard";

export function AdminBadge() {
  const isAdmin = useIsAdmin();

  // Only show for admins
  if (!isAdmin) {
    return null;
  }

  return (
    <Link
      to="/admin"
      className="flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-50 hover:bg-blue-100 border border-blue-200 transition-colors"
    >
      <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <title>Admin shield icon</title>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
        />
      </svg>
      <span className="text-sm font-medium text-blue-700">Admin</span>
    </Link>
  );
}
